import { AsyncGridColumns, ColumnLink } from '~/shared/ui/AsyncGrid'
import { ChipStatus } from '~/shared/ui/Chips'
import { GridRow } from './types'

export const columns: AsyncGridColumns<GridRow> = [
  {
    headerName: 'column.designation',
    field: 'title',
    sortable: false,
    flex: 1,
    minWidth: 500,
    renderCell: ({ row }) => <ColumnLink to={row.id}>{row.title}</ColumnLink>,
  },
  {
    headerName: 'column.status',
    field: 'status',
    sortable: false,
    minWidth: 170,
    renderCell: ({ value }) => (
      <ChipStatus labelI18n={value.label} variant={value.color} />
    ),
  },
  {
    headerName: 'column.vehicle category',
    field: 'vehicleCategory',
    sortable: false,
    minWidth: 200,
  },
  {
    headerName: 'column.car is in promotion',
    field: 'isPromotion',
    sortable: false,
    minWidth: 200,
    renderCell: ({ value }) => (
      <ChipStatus
        labelI18n={value ? 'button.yes' : 'button.no'}
        variant={value ? 'purple' : 'gray'}
      />
    ),
  },
]
